export default __webpack_public_path__ + "static/media/success.0d51882f.svg";